type SelectOption = Readonly<{ id: string; title: string }>;

type SelectOptions = Readonly<SelectOption[]>;

export const toOptions = (mapping: Record<string, string>): SelectOptions => {
  return Object.keys(mapping).map((key) => ({ id: key, title: mapping[key] }));
};
